import axios from 'axios';
import Config from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: Config.dev ? Config.api_dev : Config.api_prod,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('token');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
